var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34134 3.33329C3.34134 2.41663 4.08301 1.66663 4.99967 1.66663H10.9747C11.4163 1.66663 11.8413 1.84163 12.1497 2.15829L16.1747 6.18329C16.4913 6.49163 16.6663 6.91663 16.6663 7.35829V16.6666C16.6663 17.5833 15.9163 18.3333 14.9997 18.3333H4.99134C4.07467 18.3333 3.33301 17.5833 3.33301 16.6666L3.34134 3.33329ZM10.833 2.91663V6.66663C10.833 7.12496 11.208 7.49996 11.6663 7.49996H15.4163L10.833 2.91663Z",
    fill: "#66D1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyData);
export default __webpack_public_path__ + "static/media/my-data.3fb564fe1b0c14d57c12846751570fff.svg";
export { ForwardRef as ReactComponent };